import type { FiltersContext } from '../../context/types.ts';
import type { FilterCriteria } from '../types.ts';
import { getFilterOptions } from '../utils.ts';
import { SingleFilter } from './singleFilter/SingleFilter.tsx';

type SingleFiltersListProps<Criteria extends FilterCriteria> = {
  filters: FiltersContext<Criteria>['filtersConfig'];
};

export const SingleFiltersList = <Criteria extends FilterCriteria>({ filters }: SingleFiltersListProps<Criteria>) => {
  return (
    <>
      {filters.map(filter => {
        return <SingleFilter key={filter.key} filter={filter} options={getFilterOptions(filter)} />;
      })}
    </>
  );
};
